import React, { useEffect, useState } from "react";
import { ErrorScope, Label, Modal, Spinner, TextArea } from "acma-spa";
import { IFirewallAlphaTag } from "../../api";

export interface DeclineModalProps {
  selection: IFirewallAlphaTag[]
  open: boolean
  onClose: () => any
  onConfirm: (comments: string) => Promise<any>
}

export const DeclineModal: React.FC<DeclineModalProps> = (props) => {
  const [error, setError] = useState<string|undefined>(undefined);
  const [spinner, setSpinner] = useState<string>("");
  const [comments, setComments] = useState("");

  useEffect(() => {
    setError("");
  }, [props.open])

  const onConfirm = async () => {
    if (!comments || comments.length == 0) {
      setError("Please provide reason.");
      return;
    }
    else if(comments.length > 2000) {
      setError("Max limit is 2000 characters.")
      return;
    }
    else {
      setError("");
    }
    try {
      setSpinner("Declining");

      await props.onConfirm(comments);

      props.onClose();
    }
    catch(e: any) {
      setError(e.message ? e.message : "Unexpected error");
    }
    finally {
      setSpinner("");
    }
  }

  return <>
    {props.open ? <Modal id="contentModal" open={true} size="lg" onClose={() => !spinner && props.onClose()} title={"Confirmation"} leftButtons={[
      {
        label: "Confirm",
        id: "confirm",
        onClick: () => onConfirm(),
        disabled: spinner ? true: false
      },
      {
        label: "Cancel",
        id: "cancel",
        onClick: () => props.onClose(),
        mode: 'secondary'
      }
    ]}>
      <div id="contentContainer" className="mb-2">
        <Spinner isLoading={spinner ? true : false} loadingText={spinner}>
          <Label id="comments" label={<>Please provide reason for declining <b>{props.selection.map(r => r.name).join(", ")}</b> alpha tag(s)</>} required={true}>
            <TextArea value={comments} onChange={v => setComments(v)} />
          </Label>
        </Spinner>
      </div>
      <ErrorScope id="error" error={error} />
    </Modal> : <></>}
  </>
}